import React, { useEffect, useRef, useState } from "react";
import { Plus, ChevronDown, FilePlus2, FileUp, Repeat2, ReceiptText, Sparkles } from "lucide-react";

const OPTIONS = [
  { key: "enquiry", icon: FilePlus2, emoji: "🆕", label: "New Enquiry", desc: "Start from an inbound lead" },
  { key: "customer_po", icon: FileUp, emoji: "📄", label: "Customer PO Received", desc: "Upload a PO — AI extracts it" },
  { key: "repeat", icon: Repeat2, emoji: "🔁", label: "Repeat Order", desc: "Duplicate a previous PI" },
  { key: "direct_pi", icon: ReceiptText, emoji: "📑", label: "Direct PI", desc: "Skip enquiry — bill directly" },
];

export default function NewOrderButton({ onSelect }) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  useEffect(() => {
    const h = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", h);
    return () => document.removeEventListener("mousedown", h);
  }, []);

  return (
    <div className="relative" ref={ref}>
      <button data-testid="new-order-btn" onClick={() => setOpen((o) => !o)}
        className="h-9 inline-flex items-center gap-2 px-3 rounded-md bg-[#ab0000] hover:bg-[#8a0000] text-white text-sm font-medium">
        <Plus size={16} /> New Order <ChevronDown size={14} className={"transition-transform " + (open ? "rotate-180" : "")} />
      </button>
      {open && (
        <div className="absolute right-0 mt-2 w-72 rounded-xl border border-slate-200 bg-white shadow-xl overflow-hidden z-50 animate-fade-up" data-testid="new-order-menu">
          <div className="px-3 py-2 text-[10px] font-semibold uppercase tracking-widest text-slate-400 flex items-center gap-1.5 border-b border-slate-100">
            <Sparkles size={11} className="text-[#ab0000]" /> How would you like to start?
          </div>
          {OPTIONS.map((o) => (
            <button key={o.key} data-testid={`new-order-${o.key}`}
              onClick={() => { setOpen(false); onSelect(o.key); }}
              className="w-full flex items-start gap-3 px-3 py-2.5 text-left hover:bg-slate-50 transition-colors">
              <span className="text-lg leading-none mt-0.5">{o.emoji}</span>
              <span className="flex-1">
                <span className="flex items-center gap-2 text-sm font-medium text-slate-800">
                  {o.label}
                  {o.soon && <span className="text-[9px] font-semibold uppercase text-amber-700 bg-amber-100 rounded px-1.5 py-0.5">Soon</span>}
                </span>
                <span className="block text-[11px] text-slate-400 mt-0.5">{o.desc}</span>
              </span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
